export default __webpack_public_path__ + "static/media/automated-material-flow.cdf356ce.svg";